module.exports = __webpack_public_path__ + "img/available.8ca8ffc5.svg";